import React from 'react';
import { SxStyle } from '../../../../../types';
import CreateIcon from '@mui/icons-material/Create';
import { useStringsContext } from '../../../../../contexts/strings';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

const styles: SxStyle = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  button: {
    zIndex: 1, // Necessary due to modal overlay on DataGrid
  },
};

interface Props {
  onClick: () => void;
  isSquadEmpty: boolean;
  loading: boolean;
  disabled: boolean;
}

const CreateSquadListOverlay = ({ onClick, isSquadEmpty, loading, disabled }: Props) => {
  const { strings } = useStringsContext();

  return (
    <Stack sx={styles.container} spacing={2}>
      {isSquadEmpty ? (
        <Typography variant="italic">{strings.squad.squadEmpty}</Typography>
      ) : (
        <>
          <Typography variant="italic">{strings.squad.noSquadCreated}</Typography>
          <LoadingButton
            sx={styles.button}
            variant="contained"
            color="primary"
            startIcon={<CreateIcon />}
            onClick={onClick}
            loading={loading}
            disabled={disabled}
          >
            {strings.squad.createNewSquad}
          </LoadingButton>
        </>
      )}
    </Stack>
  );
};

export default CreateSquadListOverlay;
